var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4155_49988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.0016 0C6.43015 0 4.32812 2.10203 4.32812 4.67348C4.32812 7.24492 6.43015 9.34695 9.0016 9.34695C11.573 9.34695 13.6751 7.24492 13.6751 4.67348C13.6751 2.10203 11.573 0 9.0016 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0231 13.0801C16.9006 12.7739 16.7374 12.4882 16.5537 12.2229C15.6149 10.8351 14.1659 9.91678 12.5333 9.69228C12.3292 9.67189 12.1047 9.71267 11.9415 9.83514C11.0843 10.4678 10.0639 10.7943 9.00267 10.7943C7.94142 10.7943 6.92103 10.4678 6.06388 9.83514C5.9006 9.71267 5.67611 9.65146 5.47204 9.69228C3.83939 9.91678 2.37001 10.8351 1.45165 12.2229C1.26798 12.4882 1.1047 12.7944 0.982276 13.0801C0.921065 13.2025 0.941456 13.3454 1.00267 13.4678C1.16595 13.7535 1.37001 14.0393 1.55368 14.2842C1.83939 14.6719 2.14552 15.0188 2.49247 15.3454C2.77818 15.6311 3.1047 15.8964 3.43126 16.1617C5.04349 17.3658 6.98228 17.9984 8.98228 17.9984C10.9823 17.9984 12.9211 17.3658 14.5333 16.1617C14.8598 15.9168 15.1863 15.6311 15.4721 15.3454C15.7986 15.0188 16.1251 14.6719 16.4109 14.2842C16.6149 14.0188 16.7986 13.7535 16.9619 13.4678C17.0639 13.3454 17.0843 13.2025 17.0231 13.0801Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4155_49988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUser);
export default __webpack_public_path__ + "static/media/ProfileUser.36b848e0.svg";
export { ForwardRef as ReactComponent };